import { render, staticRenderFns } from "./huovChat.vue?vue&type=template&id=2e63364c"
import script from "./huovChat.vue?vue&type=script&lang=js"
export * from "./huovChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports